export type PortalModulePrefNavigationResult = {
  navigated: boolean
}

export const PORTAL_MODULE_PREF_NAVIGATION = {
  navigated: {navigated: true},
  skipped: {navigated: false},
} as const satisfies Record<string, PortalModulePrefNavigationResult>
